import { useTranslation } from 'react-i18next';
import { TableV2 } from '@anytag/shared-atoms';
import { InfluencerCampaignDetail } from '@anytag/graphql';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { CampaignPostDetailsModal } from '@anytag/shared-molecules';
import { useInfluencerProfileCampaignListTable } from './hooks';
import { formatInfluencerProfileCampaignsData } from './utils';

export type InfluencerProfileCampaignsListProps = TableData<InfluencerCampaignDetail>;

export const InfluencerProfileCampaignsList = ({ loading, data = [] }: InfluencerProfileCampaignsListProps) => {
  const { t } = useTranslation();
  const { columns } = useInfluencerProfileCampaignListTable();

  const formattedData = formatInfluencerProfileCampaignsData(data);
  const allPosts = formattedData.reduce<PostDetailsType[]>(
    (acc, { post, campaign }) =>
      post?.id && campaign.hasPostTracking ? [...acc, { id: String(post.id), campaignType: campaign.type }] : acc,
    []
  );
  return (
    <>
      <TableV2
        loading={loading}
        data={formattedData}
        columns={columns}
        rowHeight="70px"
        empty={{ hideDescription: true, title: t('No campaigns has been found') }}
        noTopBorderRadius
        hasBorder
      />

      <CampaignPostDetailsModal posts={allPosts} />
    </>
  );
};
